import React, { PropTypes, Component } from 'react'
import styles from './styles'
import misc from 'utils/misc'

export default class TrafficSpan extends Component {
  static propTypes = {
    segment: PropTypes.object,
  };

  constructor (props, context) {
    super(props, context)
  }

  render () {
    const { segment } = this.props

    return (
      <div className={styles.trafficSpan}>
        <span>{misc.getTimeStr(segment.start)}</span>
        <span> ～ </span>
        <span>{misc.getTimeStr(segment.end)}</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/timesheet/cell/trafficSpan.jsx